import {
  type Action,
  type ControlType,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

type BaseGalleryExtras = {
  id: string;
  gameId?: string;
  gameName?: string;
  imageIndex?: string;
  version?: string;
  controlLabel?: string;
};

type GalleryViewedEvent = {
  action: Action.VIEWED;
  extras: BaseGalleryExtras;
};

type GalleryPressedEvent = {
  action: Action.PRESSED;
  extras: BaseGalleryExtras & {
    control: string;
    controlType: ControlType;
  };
};

type GalleryHoverEvent = {
  action: Action.HOVER;
  extras: BaseGalleryExtras & {
    control: string;
    controlType: ControlType;
  };
};

export type GalleryEvent =
  | GalleryViewedEvent
  | GalleryPressedEvent
  | GalleryHoverEvent;

export const useGalleryAnalytics = () =>
  useAnalyticsTracker<GalleryEvent>(TrackObject.GALLERY);
